<template>
  <div class='lt-scene-personal'>
    <Transition name='slideY-down' v-show="personal > 0">
      <img
        src="../../assets/bag1.svg"
        class='lt-scene-personal-bag-1'
        alt=""
      />
    </Transition>

    <Transition name='slideY-down' v-show="personal > 2">
      <img
        src="../../assets/bag3.svg"
        class='lt-scene-personal-bag-3'
        alt=""
      />
    </Transition>

    <Transition name='slideY-down' v-show="personal > 1">
      <img
        src="../../assets/bag2.svg"
        class='lt-scene-personal-bag-2'
        alt=""
      />
    </Transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.personal',
    ]),
  },
};
</script>
